import React from "react";
import './ActivityInputCard.css';
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardContent from "@mui/material/CardContent";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Slider from "@mui/material/Slider";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import Input from "@mui/material/Input";

export const ActivityInputCard = ({
  name = "Activity Name",
  notes = "",
  durationMinutes = 0,
  maxDuration = 120,
  onChange,
  onRemove,
}) => {
  const handleDurationChange = (event, newValue) => {
    onChange?.({ durationMinutes: newValue });
  };

  const handleNotesChange = (e) => {
    onChange?.({ notes: e.target.value });
  };

  const durationValue = Number(durationMinutes) || 0;

  const [inputValue, setInputValue] = React.useState(durationValue);

  const handleInputChange = (event) => {
    const value = event.target.value;
    setInputValue(value);
  };

  const handleInputBlur = () => {
    let numValue = Number(inputValue);
    if (isNaN(numValue) || numValue < 0) {
      numValue = 0;
    } else if (numValue > maxDuration) {
      numValue = maxDuration;
    }
    setInputValue(numValue.toString());
    onChange?.({ durationMinutes: numValue });
  };

  React.useEffect(() => {
    setInputValue(durationValue);
  }, [durationValue]);

  return (
    <Card variant="outlined" className="activity-input-card">
      <CardHeader
        title={
          <Typography variant="subtitle1" className="activity-input-card-title">
            {name}
          </Typography>
        }
        action={
          <IconButton aria-label="remove" onClick={onRemove}>
            <CloseIcon />
          </IconButton>
        }
        className="activity-input-card-header"
      />

      <CardContent className="activity-input-card-content">
        <Stack spacing={2}>
          <Box>
            <Box className="activity-duration-row">
              <div className="activity-duration-slider-label">
                <Typography variant="body2" color="text.secondary">
                  Duration
                </Typography>
                <div className="activity-duration-slider-label-right">
                  <Input
                    value={inputValue}
                    onChange={handleInputChange}
                    onBlur={handleInputBlur}
                    size="small"
                    variant="outlined"
                    inputProps={{
                      step: 5,
                      min: 0,
                      max: maxDuration,
                      type: "number",
                      "aria-labelledby": "input-slider",
                      className: "activity-duration-input",
                    }}
                  />
                  <Typography variant="body2" className="activity-duration-unit">
                    min
                  </Typography>
                </div>
              </div>
            </Box>

            <Slider
              aria-label="Duration"
              value={durationValue}
              onChange={handleDurationChange}
              valueLabelDisplay="auto"
              step={5}
              min={0}
              max={maxDuration}
            />
          </Box>

          <TextField
            fullWidth
            multiline
            maxRows={4}
            value={notes}
            onChange={handleNotesChange}
            placeholder="Optional Notes"
            variant="outlined"
            size="small"
          />
        </Stack>
      </CardContent>
    </Card>
  );
};
